import { NativeBridgeService } from 'scbk-services/bridge';

/**
 * as-is 네이티브 함수 호출 어댑터
 * 이벤트/공지사항 등에서 as-is 브릿지 함수를 직접 호출하는경우. to-be 브릿지 함수를 호출하도록 한다.
 */
export const MA30Native = {
    /**
     * 외부브라우져(사라피, 크롬)열기
     * @param url 외부 브라우저 호출 url 문자열
     */
    async doNWebBrowser(url: string) {
        const nativeBridgeService: NativeBridgeService = NativeBridgeService.getInstance();

        await nativeBridgeService.call(
            'doNWebBrowser',
            {
                url,
            },
            { onlyRequest: true },
        );
    },
};
